import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { ko } from 'date-fns/locale';

import "../../styles/font.css";
import { TopMenu } from '../../component/TopMenu';
import { formatPhoneNumber } from '../../utils/format';
import { API_CONFIG } from '../../config/api';

import "./StudioDetail.css";
import "./StudioDetail_artworks.css";

const artlog_ip = process.env.REACT_APP_ARTLOG_IP;

export const StudioDetail = () => {
  const navigate = useNavigate();
  const { tourId } = useParams();  // tour_overview의 id가 param에 저장
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userType, setUserType] = useState(null);
  const [userName, setUserName] = useState('');
  
  const [selectedAmount, setSelectedAmount] = useState(1);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTime, setSelectedTime] = useState('');

  const [tourData, setTourData] = useState(null);
  const [availableTimes, setAvailableTimes] = useState([]);

  const [searchKeyword, setSearchKeyword] = useState('');

  const [totalPrice, setTotalPrice] = useState(0);

  const [artistRecords, setArtistRecords] = useState([]);
  const [artworks, setArtworks] = useState([]);
  const [artistInfo, setArtistInfo] = useState(null);

  const fetchTourData = async () => {
    try {
      const response = await fetch(`${API_CONFIG.MAIN}/get_tour_overview_by_id`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ tour_id: tourId })
      });

      if (!response.ok) {
        throw new Error('투어 데이터 가져오기 실패');
      }
      const data = await response.json();
      if (data.isSuccess) {
        setTourData(data.tour);
        calculateAvailableTimes(data.tour);
        // 작가의 작품 정보와 작가 정보 가져오기
        if (data.tour.artist_id) {
          fetchArtworks(data.tour.artist_id);
          fetchArtistInfo(data.tour.artist_id);
        }
      }
    } catch (error) {
      console.error('투어 데이터 가져오기 실패:', error);
    }
  };

  const fetchArtistInfo = async (artistId) => {
    try {
      const response = await fetch(`${API_CONFIG.MAIN}/get_artist_info`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ artist_id: artistId })
      });

      if (!response.ok) throw new Error('작가 정보 조회 실패');
      const data = await response.json();
      if (data.isSuccess) {
        setArtistInfo(data.artistInfo);
      }
    } catch (error) {
      console.error('작가 정보 조회 실패:', error);
    }
  };

  const fetchArtworks = async (artistId) => {
    try {
      const response = await fetch(`${API_CONFIG.MAIN}/get_artist_artworks`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ artist_id: artistId })
      });

      if (!response.ok) throw new Error('작품 목록 조회 실패');
      const data = await response.json();
      if (data.isSuccess) {
        const artworksWithUrls = data.artworks.map(artwork => ({
          ...artwork,
          imageUrl: `${API_CONFIG.MAIN}/uploads/artworks/${artwork.artwork_image}`
        }));
        setArtworks(artworksWithUrls.reverse());
      }
    } catch (error) {
      console.error('작품 목록 조회 실패:', error);
    }
  };

  const calculateAvailableTimes = (tour) => {
    console.log('tour', tour);
    if (!tour || !selectedDate) return;

    const dayOfWeek = selectedDate.getDay();
    const openDays = tour.tour_open_days.split(',').map(Number);
    
    if (!openDays.includes(dayOfWeek)) {
      setAvailableTimes([]);
      return;
    }

    const [openTime, closeTime] = [tour.tour_open_time, tour.tour_close_time];
    const [breakStart, breakEnd] = tour.tour_break_time.split('-');

    console.log('openTime', openTime);
    console.log('closeTime', closeTime);
    console.log('breakStart', breakStart);
    console.log('breakEnd', breakEnd);
    
    let currentTime = new Date(`2000-01-01 ${openTime}`);
    const endTime = new Date(`2000-01-01 ${closeTime}`);
    const times = [];

    while (currentTime < endTime) {
      const timeStr = currentTime.toTimeString().slice(0, 5);
      if (timeStr < breakStart || timeStr >= breakEnd) {
        times.push(timeStr);
      }
      currentTime.setMinutes(currentTime.getMinutes() + 60); // 1시간 간격
    }
    
    setAvailableTimes(times);
  };

  // 총 가격 계산
  const calculateTotalPrice = (amount) => {
    if (!tourData) return;
    const price = parseInt(tourData.tour_price) || 0;
    setTotalPrice(price * amount);
  };

  const fetchArtistRecords = async (artistId) => {
    try {
      // 1. 먼저 서버에서 artlog_token 가져오기
      console.log('[fetchArtistRecords] artistId: ', artistId);
      const tokenResponse = await fetch(`${API_CONFIG.MAIN}/get_artist_token`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ artist_id: artistId }),
      });
  
      if (!tokenResponse.ok) {
        throw new Error('Failed to get artist token');
      }
  
      const tokenData = await tokenResponse.json();
      
      if (!tokenData.isSuccess) {
        throw new Error(tokenData.message);
      }
  
      // 2. artlog_token으로 작가 기록 가져오기
      const recordResponse = await fetch(`${artlog_ip}:3541/api/get_artist_record`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          auth_token: tokenData.artlog_token
        })
      });
  
      if (!recordResponse.ok) {
        throw new Error('Failed to fetch artist records');
      }
  
      const recordData = await recordResponse.json();
      
      if (recordData.isSuccess) {
        setArtistRecords(recordData.records);
      } else {
        setArtistRecords([]);
      }
    } catch (error) {
      console.error('Error fetching artist records:', error);
      setArtistRecords([]);
    }
  };
  useEffect(() => {
    if (tourData && tourData.artist_id) {
      fetchArtistRecords(tourData.artist_id);
    }
  }, [tourData]);

  useEffect(() => {
    fetchTourData();
  }, [tourId]);

  useEffect(() => {
    if (tourData) {
      calculateAvailableTimes(tourData);
    }
  }, [selectedDate, tourData]);

  useEffect(() => {
    calculateTotalPrice(selectedAmount);
  }, [selectedAmount, tourData]);

  useEffect(() => {
    const userAuthToken = getCookie('yournest_u_auth_token');
    
    if (userAuthToken) {
      setIsAuthenticated(true);
      setUserType('user');
      setUserName(getCookie('yournest_u_name'));
    } else {
      // 인증되지 않은 사용자는 로그인 페이지로 리다이렉트
      alert('로그인이 필요한 서비스입니다.');
      navigate('/login');
    }
  }, [navigate]);

  function getCookie(name) {
    let cookieArray = document.cookie.split(';');
    for (let i = 0; i < cookieArray.length; i++) {
      let cookiePair = cookieArray[i].trim().split('=');
      if (cookiePair[0] === name) {
        return decodeURIComponent(cookiePair[1]);
      }
    }
    return null;
  }

  const handleLogout = () => {
    document.cookie = "yournest_u_auth_token=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    setIsAuthenticated(false);
    alert("로그아웃 되었습니다");
  };

  const gotoMain = () => {
    navigate('/');
  }

  const goToStudioTour = () => {
    navigate('/studio-tour');
  }

  const handlePayment = () => {
    if (!isAuthenticated || userType !== 'user') {
      alert('로그인이 필요한 서비스입니다.');
      navigate('/login');
      return;
    }

    // userId도 함께 전달
    navigate('/studio-payment', {
      state: {
        tourId: tourId,
        userId: getCookie('yournest_u_id'),
        tourName: tourData.tour_name,
        reservationDate: selectedDate,
        reservationTime: selectedTime,
        amount: selectedAmount,
        totalPrice: totalPrice
      }
    });
  };

  const isReservationValid = () => {
    return (
      selectedAmount > 0 && 
      selectedDate !== null && 
      selectedTime !== '' && 
      isAuthenticated && 
      userType === 'user'
    );
  };

  return (
    <div className="studio-detail">
      <TopMenu 
        isAuthenticated={isAuthenticated}
        userType={userType}
        searchKeyword={searchKeyword}
        setSearchKeyword={setSearchKeyword}
        handleLogout={handleLogout}
      />
      {artistRecords.length > 0 && (
        <div className="portfolio-area">
          <div className="portfolio-area__title-text">작가의 포트폴리오</div>
          <div className="portfolio-area__image-block">
            {artistRecords.map(record => (
              <img
                key={record.id}
                src={`${artlog_ip}:3541/${record.record_photo}`}
                alt={record.record_subject}
                className="portfolio-image"
              />
            ))}
          </div>
        </div>
      )}
      <div className="bottom-area">
        <div className="studio-info-area">
          <div className="studio-info-area__title-text">정보</div>
          <div className="studio-info-area__block-area">
            <img className="studio-info-area__block-icon" src="/icons/icon_location.svg" />
            <div className="studio-info-area__block-text">{tourData?.tour_location || '위치 정보 없음'}</div>
          </div>
          <div className="studio-info-area__block-area">
            <img className="studio-info-area__block-icon" src="/icons/icon_opentime.svg" />
            <div className="studio-info-area__block-text">
              영업시간: {tourData?.tour_open_time || '10:00'} - {tourData?.tour_close_time || '18:00'}
              <br />
              브레이크타임: {tourData?.tour_break_time || '12:00-13:00'}
            </div>
          </div>
          <div className="studio-info-area__block-area">
            <img className="studio-info-area__block-icon" src="/icons/icon_phone.svg" />
            <div className="studio-info-area__block-text">{formatPhoneNumber(tourData?.tour_phone)}</div>
          </div>
          <div className="studio-info-area__block-area">
            <img className="studio-info-area__block-icon" src="/icons/icon_homepage.svg" />
            <div className="studio-info-area__block-text">{tourData?.tour_website || '웹사이트 정보 없음'}</div>
          </div>

          {artworks.length > 0 && (
            <>
              <div className="studio-info-area__title-text" style={{marginTop: '32px'}}>작품</div>
              <div className="studio-info-area__artworks-scroll">
                {artworks.map((artwork) => (
                  <div key={artwork.id} className="studio-info-area__artwork-card">
                    <img
                      src={artwork.imageUrl}
                      alt={artwork.artwork_name}
                      className="studio-info-area__artwork-image"
                    />
                    <div className="studio-info-area__artwork-info">
                      <div className="studio-info-area__artwork-name">{artwork.artwork_name}</div>
                      {artwork.artwork_year && (
                        <div className="studio-info-area__artwork-detail">{artwork.artwork_year}년</div>
                      )}
                      {artwork.artwork_size && (
                        <div className="studio-info-area__artwork-detail">{artwork.artwork_size}cm</div>
                      )}
                      {artwork.artwork_material && (
                        <div className="studio-info-area__artwork-detail">{artwork.artwork_material}</div>
                      )}
                      {artwork.artwork_description && (
                        <div className="studio-info-area__artwork-description">{artwork.artwork_description}</div>
                      )}
                      {artwork.artwork_price && (
                        <div className="studio-info-area__artwork-price">
                          {parseInt(artwork.artwork_price).toLocaleString()}원
                        </div>
                      )}
                      {artwork.emotion_tags && artwork.emotion_tags.length > 0 && (
                        <div className="studio-info-area__artwork-tags">
                          <div className="studio-info-area__artwork-tags-label">감정</div>
                          <div className="studio-info-area__artwork-tags-list">
                            {artwork.emotion_tags.map((tag, i) => (
                              <span key={i} className="studio-info-area__artwork-tag">{tag}</span>
                            ))}
                          </div>
                        </div>
                      )}
                      {artwork.situation_tags && artwork.situation_tags.length > 0 && (
                        <div className="studio-info-area__artwork-tags">
                          <div className="studio-info-area__artwork-tags-label">상황</div>
                          <div className="studio-info-area__artwork-tags-list">
                            {artwork.situation_tags.map((tag, i) => (
                              <span key={i} className="studio-info-area__artwork-tag">{tag}</span>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
        {/* 우측 하단: studio-reservation-area */}
        <div className="studio-reservation-area">
          {/* 좌측 상단: 관련 정보 명시 */}
          <div className="studio-reservation-area__info-area">
            <div className="studio-reservation-area__info-title">{tourData?.tour_name || '투어 정보 없음'}</div>
            <div className="studio-reservation-area__info-tag-block">
              <div className="studio-reservation-area__info-tag-text">취소규정 확인</div>  
              {/* <div className="studio-reservation-area__info-tag-text">바우처 즉시 확정</div> */}
            </div>
            <div className="studio-reservation-area__info-amount-title">수량/인원 선택</div>
            <div className="studio-reservation-area__info-amount-description">최소 1명부터 최대 {tourData?.tour_max_per_time || 20}명까지 예약할 수 있습니다</div>

            <div className="studio-reservation-area__amount-selector">
              <button 
                onClick={() => setSelectedAmount(prev => Math.max(1, prev - 1))}
                disabled={selectedAmount <= 1}
              >
                -
              </button>
              <span>{selectedAmount}명</span>
              <button 
                onClick={() => setSelectedAmount(prev => Math.min(tourData?.tour_max_per_time || 20, prev + 1))}
                disabled={selectedAmount >= (tourData?.tour_max_per_time || 20)}
              >
                +
              </button>
            </div>
            <div className="studio-reservation-area__reserved-price">
              {totalPrice.toLocaleString()}원
            </div>
          </div>
          {/* 우측 상단: 달력 및 시간 */}
          <div className="studio-reservation-area__datetime-area">
            <div className="studio-reservation-area__date-picker-block">
              <div className="studio-reservation-area__date-picker-label">날짜 선택</div>
              <DatePicker
                selected={selectedDate}
                onChange={(date) => setSelectedDate(date)}
                dateFormat="yyyy/MM/dd"
                minDate={new Date()}
                locale={ko}
                className="studio-reservation-area__date-picker"
                filterDate={(date) => {
                  const dayOfWeek = date.getDay();
                  let openDays = tourData?.tour_open_days;
                
                  if (typeof openDays === 'string') {
                    try {
                      openDays = JSON.parse(openDays);
                    } catch {
                      openDays = openDays.split(',').map(Number);
                    }
                  }
                
                  return openDays.includes(dayOfWeek);
                }}
                popperPlacement="top-start"
                popperProps={{
                  modifiers: [
                    {
                      name: 'offset',
                      options: {
                        offset: [0, 0],
                      },
                    },
                  ],
                }}
              />
            </div>
            <div className="studio-reservation-area__time-picker-block">
              <div className="studio-reservation-area__time-picker-label">시간 선택</div>
              <select 
                value={selectedTime} 
                onChange={(e) => setSelectedTime(e.target.value)}
                className="studio-reservation-area__time-picker"
              >
                <option value="">시간을 선택하세요</option>
                {availableTimes.map(time => (
                  <option key={time} value={time}>{time}</option>
                ))}
              </select>
            </div>
          </div>
          {/* 하단: 예약하기 */}
          <div 
            className={`studio-reservation-area__reservation-button${!isReservationValid() ? '--disabled' : ''}`}
            onClick={() => isReservationValid() && handlePayment()} >
            예약하기
          </div>
        </div>
      </div>

    </div>
  );
}